import { render, staticRenderFns } from "./Staff04.vue?vue&type=template&id=2a61a95d&scoped=true&"
import script from "./Staff04.vue?vue&type=script&lang=js&"
export * from "./Staff04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61a95d",
  null
  
)

export default component.exports